import { render, staticRenderFns } from "./EnvironmentSelection.vue?vue&type=template&id=6b8a04b4&"
import script from "./EnvironmentSelection.vue?vue&type=script&lang=js&"
export * from "./EnvironmentSelection.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports